export class ContactSourceModel {
  public id: number;
  public descrizione: string;
  public enabled: boolean;
  public creator: string;
  public created: Date;
  public modifier: string;
  public modified: Date;
}
